(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.draws = svs.numbergames.draws || {};
svs.numbergames.draws.internal = svs.numbergames.draws.internal || {};
svs.numbergames.draws.drawsApi = svs.numbergames.draws.drawsApi || {};
svs.numbergames.draws.asyncDrawsApi = svs.numbergames.draws.asyncDrawsApi || {};
svs.numbergames.draws.jackpotApi = svs.numbergames.draws.jackpotApi || {};
svs.numbergames.draws.asyncJackpotApi = svs.numbergames.draws.asyncJackpotApi || {};
svs.numbergames.draws.drawsUtils = svs.numbergames.draws.drawsUtils || {};
svs.numbergames.draws.asyncDrawsUtils = svs.numbergames.draws.asyncDrawsUtils || {};
svs.numbergames.draws.logger = new svs.core.log.Logger('numbergames:draws');

 })(window);